import { render, staticRenderFns } from "./EventsSwiper.vue?vue&type=template&id=308ad56c&scoped=true&"
import script from "./EventsSwiper.vue?vue&type=script&lang=js&"
export * from "./EventsSwiper.vue?vue&type=script&lang=js&"
import style0 from "./EventsSwiper.vue?vue&type=style&index=0&id=308ad56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ad56c",
  null
  
)

export default component.exports